module.exports = __webpack_public_path__ + "static/TQLD-Map-2.eaf320f0.jpg";